export default {
    'component.purchasing.title': 'Innkjøpskontrakt',    
    'component.purchasing.content': 'Når kontrakten er klar for signering, kan du klikke på knappen nedenfor for å få en elektronisk signatur av både kontrakt og andre dokumenter relatert til salget.',
    'component.purchasing.button': 'Signer en kjøpekontrakt',
};  